import React from "react";
import UiButton from "../../ui/UiButton";
import { ICON } from "../../../assets";
import UiIcon from "../../ui/UiIcon";
import "./ItemController.css";
import UiTag from "../../ui/UiTag";
import { UI_TAG_TYPE } from "../../ui/UiTag/index";

function ItemController({
  addAction = () => {},
  removeAction = () => {},
  emptyAction = () => {},
  count,
  minOrderCount = 1,
  itemName,
  currentPrice,
  isControllerShow = true,
  discountLabel,
  disableControls = false,
}) {
  function renderAddRemoveButtons() {
    if (!isControllerShow) {
      return (
        <React.Fragment>
          <div className="itemcontroller-only-count-show">
            <div
              className="itemcontroller-quantity"
              style={{ fontSize: "15px" }}
            >
              {count}
            </div>
          </div>
        </React.Fragment>
      );
    }
    const buttonStyle = {
      padding: "0 4px",
    };
    return (
      <React.Fragment>
        <div className="itemcontroller-add-remove-buttons">
          {!disableControls && (
            <UiButton
              content={
                <UiIcon icon={ICON.minusIcon} alt="minus-icon" size={10} />
              }
              style={buttonStyle}
              onClick={removeAction}
              disabled={count <= minOrderCount}
            />
          )}

          <div className="itemcontroller-quantity" style={{ fontSize: "15px" }}>
            {count}
          </div>
          {!disableControls && (
            <UiButton
              content={
                <UiIcon icon={ICON.plusIcon} alt="plus-icon" size={10} />
              }
              style={buttonStyle}
              onClick={addAction}
            />
          )}
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="itemcontroller-container">
        <div className="itemcontroller-item-info">
          {discountLabel && (
            <UiTag
              content={
                <span className="itemcontroller-tag">
                  {discountLabel ? "-" + discountLabel + "%" : "-0%"}
                </span>
              }
              uiTagType={UI_TAG_TYPE.highlightColor}
              style={{ marginRight: "5px" }}
            />
          )}
          <span>{itemName}</span>
        </div>
        <div className="itemcontroller-controls">
          <div className="itemcontroller-actions">
            {renderAddRemoveButtons()}
            {!disableControls && (
              <UiIcon
                icon={ICON.trashIcon}
                onClick={emptyAction}
                alt="trashIcon"
                size={22}
                style={{ cursor: "pointer", marginLeft: "10px" }}
              />
            )}
          </div>
          <div>{currentPrice && <span>{currentPrice}{" "}€</span>}</div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default ItemController;
